/**
 * @generated SignedSource<<8c14a68e88d16a38f43d08cea6b69d21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsModalHeader_viewer$data = {
  readonly feedbackFormPhotoUpload: boolean | null;
  readonly reviewsWithPhotos: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "SellerReviewsModalHeader_viewer";
};
export type SellerReviewsModalHeader_viewer$key = {
  readonly " $data"?: SellerReviewsModalHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerReviewsModalHeader_viewer",
  "selections": [
    {
      "alias": "feedbackFormPhotoUpload",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "feedbackFormPhotoUpload"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"feedbackFormPhotoUpload\")"
    },
    {
      "alias": "reviewsWithPhotos",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeInAppealProcess",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "excludePrivateItemReviews",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        },
        {
          "kind": "Literal",
          "name": "hasVisibleFeedbackImages",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "orderByNewest",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": 0
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "OrderFeedbackMultipleQueryConnection",
      "kind": "LinkedField",
      "name": "orderFeedbackMultiple",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a78195e8dd33db231de716e56513942e";

export default node;
